export default {
  title: 'Odstrániť dáta hodnôt zákazky',
  confirmDelete: {
    header: 'Odstrániť hodnoty "{item}"?',
    message: 'Všetky hodnoty od {from} do {to} sa odstránia. Túto akciu nie je možné vrátiť späť.',
  },
};
